import { TopHeader } from './TopHeader';
import { BottomHeader } from './BottomHeader';

const headerStyle = {
    display:'flex', 
    flexDirection:'column', 
    justifyContent:'start',
    boxShadow:'0px 0px 5px 1px black',
    zIndex:999
  }

export function Header() {
  return (
    <div style={headerStyle}>
        <TopHeader/>
        {/* <BottomHeader/> */}
    </div>
  );
}